import { helpers } from 'vuelidate/lib/validators'

export const postalCode = helpers.regex('postalCode', /^[0-9]{4}\s?[a-zA-Z]{2}$/)
